import { defaultVertexShader } from '.'

const vhsFragmentShader = `
    precision mediump float;
    
    varying vec2 v_texcoord;
    
    uniform float u_intensity;
    uniform float u_progress;
    uniform sampler2D u_texture;

    const float PI = 3.14159265;

    float rand(vec2 co) {
        return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);
    }
    
    void main() {
        float strength = 8.0;
        float time = u_progress;
        vec2 uv = v_texcoord;
        vec4 original = texture2D(u_texture, uv);

        //  wobble
        vec2 wobble = vec2(0.003 * rand(vec2(time, uv.y)), 0.);

        //  band distortion
        float t_val = tan(0.5 * time + uv.y * PI * -1.3) * u_intensity;
        vec2 tan_off = vec2(wobble.x * min(0., t_val), 0.);

        //  chromab
        vec4 color1 = texture2D(u_texture, uv + wobble + tan_off);
        vec4 color2 = texture2D(u_texture, (uv + (wobble * 1.5) + (tan_off * 1.3)) * 1.005);
        //  combine + grade
        vec4 color = vec4(color2.rg, pow(color1.b, .9), 1.);
        color.rgb = mix(texture2D(u_texture, uv + tan_off).rgb, color.rgb, 0.4);

        float x = (uv.x + 4.0) * (uv.y + 4.0) * ((time + 0.5) * 10.0);
        vec4 grain = vec4(mod((mod(x, 13.0) + 1.0) * (mod(x, 123.0) + 1.0), 0.01) - 0.005) * strength;
        color = color + grain;
        original = original + grain;

        float vig = 1. - sin(PI * uv.x) * sin(PI * uv.y);
        vec4 effect = vec4(color.rgb - (vig * 0.05), color.a);
        gl_FragColor = vec4(mix(original, effect, 1.).rgb, original.a);
    }
`

export const vhsShaderSource = {
    fragment: vhsFragmentShader,
    vertex: defaultVertexShader,
}
